import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { SmsSettingsMessages as messages } from './SMSSettings.i18n';
import { ErrorRequired } from '../FormFields/ErrorRequired';
import { formatPhoneNumber, removePhoneFormatting } from '../../shared/stringUtilities';

class SMSSettingsInternal extends React.Component {
  handlePhoneChange = (event) => {
    this.props.onInputChange(
      event.target.name,
      removePhoneFormatting(event.target.value));
  }

  handleSelectChange = (event) => {
    let selectval = event.target.value;
    if (!isNaN(selectval)) {
      selectval = parseInt(event.target.value, 10);
    }
    this.props.onInputChange(
      event.target.name,
      selectval
    );
  }

  render = () => {
    const formattedPhoneNumber = formatPhoneNumber(this.props.smsPhoneNumber);
    const inputClasses = classNames({
      'form-control': true,
      'is-invalid': this.props.isDisplayRequiredFailed,
    });

    return (
      <div>
        <label className="form-label bold">
          <FormattedMessage {...messages.SMSSettings.SMSLabel} />
        </label>
        <div className="row">
          <div className="mb-3">
            <label className="sr-only" htmlFor="exampleMobilePhone">
              <FormattedMessage {...messages.SMSSettings.phoneLabel} />
            </label>
            <input type="tel" className={inputClasses} id="exampleMobilePhone"
              onChange={this.handlePhoneChange}
              placeholder={this.props.intl.formatMessage(messages.SMSSettings.phonePlaceHolder)}
              value={ formattedPhoneNumber }
              name={this.props.phonePropertyName}
            />
            <ErrorRequired isDisplay={this.props.isDisplayRequiredFailed } />
          </div>
        </div>
      </div>
    );
  }
}

SMSSettingsInternal.propTypes = {
  intl: PropTypes.object.isRequired,
  smsPhoneNumber: PropTypes.string,
  onInputChange: PropTypes.func,
  isDisplayRequiredFailed: PropTypes.bool,
  phonePropertyName: PropTypes.string.isRequired,
};

export const SMSSettings = SMSSettingsInternal;